import {
  cilAccountLogout,
  cilAddressBook,
  cilAirplaneMode,
  cilApplicationsSettings,
  cilArrowThickToRight,
  cilArrowTop,
  cilBadge,
  cilBook,
  cilBriefcase,
  cilCalculator,
  cilCarAlt,
  cilChart,
  cilCheckCircle,
  cilChevronBottom,
  cilChevronTop,
  cilCommentBubble,
  cilCommentSquare,
  cilCopy,
  cilDescription,
  cilEnvelopeOpen,
  cilExternalLink,
  cilFilterX,
  cilGradient,
  cilHistory,
  cilInfo,
  cilListRich,
  cilLockLocked,
  cilMoney,
  cilPencil,
  cilPeople,
  cilReload,
  cilSpeedometer,
  cilSpreadsheet,
  cilTransfer,
  cilTrash,
  cilUser,
  cilWarning } from '@coreui/icons';

export const icons = Object.assign({}, {
  cilSpeedometer,
  cilSpreadsheet,
  cilApplicationsSettings,
  cilUser,
  cilMoney,
  cilChart,
  cilBriefcase,
  cilAddressBook,
  cilAccountLogout,
  cilPeople,
  cilEnvelopeOpen,
  cilLockLocked,
  cilFilterX,
  cilArrowTop,
  cilAirplaneMode,
  cilTransfer,
  cilBadge,
  cilCalculator,
  cilBook,
  cilInfo,
  cilDescription,
  cilTrash,
  cilCommentBubble,
  cilCommentSquare,
  cilCopy,
  cilExternalLink,
  cilPencil,
  cilListRich,
  cilHistory,
  cilCheckCircle,
  cilReload,
  cilWarning,
  cilGradient,
  cilChevronBottom,
  cilChevronTop,
  cilArrowThickToRight,
  cilCarAlt,
});
